import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as Styles from './SearchStyles';
import Menu from '../../components/application/Menu';
import OnboardingComponent from '../../components/application/OnboardingComponent/OnboardingComponent';
import Icon from '../../components/ui/Icon';
import Banner from '../../components/ui/Banner';
import { AppState } from '../../store';
import { useTrackingProperties } from '../../monitoring/utils';
import { trackPageView } from '../../monitoring/page-view';
import { interactionEventPages } from '../../monitoring/interaction/dispensation-home';

interface SearchProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

const Search: React.FC<SearchProps> = ({ value, onChange, onSubmit }) => {
  /*
    * Hooks
  */
  const hasBanner = useSelector((state: AppState) => state.banner.hasBanner);

  const { drugstoreId, drugstoreChainId } = useTrackingProperties()

  useEffect(() => {
    if (!drugstoreId || !drugstoreChainId || drugstoreId === 'undefined' || drugstoreChainId === 'undefined') {
      return;
    }
    trackPageView({
      page: interactionEventPages.dispensador_home,
      properties: {
        drugstore_id: drugstoreId,
        drugstore_chain_id: drugstoreChainId,
      },
    });
  }, [drugstoreId, drugstoreChainId])

  return (
    <Styles.Container>
      <Menu />
      <Styles.Page>
        <Styles.Wrapper>
          <Styles.WrapperForm hasBanner={hasBanner}>
            <Styles.Form onSubmit={onSubmit} autoComplete="off">
              <Styles.Input
                placeholder="Digite o token da receita"
                name="token"
                onChange={onChange}
                value={value}
                autoFocus
              />
              <Styles.Button>
                <Icon name="arrow-right" />
              </Styles.Button>
            </Styles.Form>
          </Styles.WrapperForm>
          <Banner page="search" />
        </Styles.Wrapper>
        <OnboardingComponent />
      </Styles.Page>
    </Styles.Container>
  );
};

export default Search;
